import AsyncStorage from '@react-native-async-storage/async-storage';
import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';
import {IUser, INetworkAccount} from '../types/Auth';

interface UserState {
  user: IUser | INetworkAccount | null;
  userType: 'network' | 'client' | null;
  networkAccountId: number | null;
  catalogBlocked: boolean;
  catalogBlockedMessage: string | null;
  temporaryPasswordLogin: boolean;
  setUser: (user: IUser | INetworkAccount) => void;
  setUserType: (type: 'network' | 'client') => void;
  setNetworkAccountId: (id: number | null) => void;
  setCatalogBlocked: (blocked: boolean, message?: string) => void;
  setTemporaryPasswordLogin: (value: boolean) => void;
  clearUser: () => void;
}

export const useUserStore = create(
  persist<UserState>(
    set => ({
      user: null,
      userType: null,
      networkAccountId: null,
      catalogBlocked: false,
      catalogBlockedMessage: null,
      temporaryPasswordLogin: false,

      setUser: (user: IUser | INetworkAccount) => set(() => ({user})),

      setUserType: (type: 'network' | 'client' | 'user') => set(() => ({userType: type})),

      setNetworkAccountId: (id: number | null) => set(() => ({networkAccountId: id})),

      setCatalogBlocked: (blocked: boolean, message?: string) =>
        set(() => ({catalogBlocked: blocked, catalogBlockedMessage: message ?? null})),

      setTemporaryPasswordLogin: (value: boolean) =>
        set(() => ({temporaryPasswordLogin: value})),

      clearUser: () =>
        set(() => ({
          user: null,
          userType: null,
          networkAccountId: null,
          catalogBlocked: false,
          catalogBlockedMessage: null,
          temporaryPasswordLogin: false,
        })),
    }),
    {
      name: 'user_store',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
